import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'

export default function Complete_projects() {
    const [listProjectArray, setListProjectArray] = useState([]);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        var company_id = localStorage.getItem('mem_company_id');
        var comname = localStorage.getItem('mem_company_name');
        var obj = {
            companyId: company_id
        };

        fetch('getAllProjects.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.json()) // IMPORTANT: parse JSON here
            .then(parsedResult => {
                console.log(parsedResult);

                if (Array.isArray(parsedResult) && parsedResult.length > 0) {
                    setListProjectArray(parsedResult);
                } else {
                    showAlert('No active projects found for your company.');
                    setListProjectArray([]);
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
                showAlert('Failed to load project data.');
                setListProjectArray([]);
            });
    }, []);

    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    function goForProjectDetails(id, pro_name, pr_last_date) {
        localStorage.setItem('selected_project_id', id);
        localStorage.setItem('selected_project_name', pro_name);
        localStorage.setItem('initialpage', 'members');
        localStorage.setItem('deadline', pr_last_date);
        navigate('/complete_project_details');
    }

    function reactiveProject(id) {
        var obj = {
            primary_key: id
        };

        fetch('reactiveProject.php', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: new URLSearchParams(obj)
        })
            .then(response => response.text()) // IMPORTANT: because PHP returns plain text
            .then(result => {
                if (result !== 'fail') {
                    showAlert('Project status updated successfully');
                    setTimeout(resetlist, 1500);
                } else {
                    showAlert('Cannot updated project status.');
                }
            })
            .catch(error => {
                console.error("Fetch Error:", error);
            });
    }

    function resetlist() {
        navigate('/re_complete_procectlist');
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };
    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Completed Projects</h2>
                    <Link className='pull_right add_new_pro' to="/projectlist">Back To Active Projects</Link>

                </div>
                <section className='vl_dsh_bodypart_section pos_rel'>
                    <div className='vl_listing_area'>

                        {listProjectArray.map((item, index) => {
                            const activestatus = item.pr_complete_status === 'complete';
                            if (!activestatus) return null; // skip inactive items

                            return (
                                <div className='resource_card_one_third' key={index}>
                                    <div className='resource_inner'>
                                        <div className='fullwidth pull_left pt-21'>
                                            <h3>{item.pro_name}</h3>
                                            <div className='fullwidth pull_left pb-10'>
                                                <span>Date : {item.pr_start_date}</span>
                                                <span>Worked Time : {item.pr_overall_prog}</span>
                                            </div>
                                        </div>
                                        <div className='divider'>&nbsp;</div>

                                        <div className='vl_dsh_one_half'>
                                            <p>Member: {item.pr_team}</p>
                                        </div>

                                        <div className='vl_dsh_one_full'>
                                            <p>Completed On: {item.actual_complete}</p>
                                        </div>

                                        <div className='vl_dsh_one_full'>
                                            <p>Deadline: {item.pr_last_date}</p>
                                        </div>

                                        <div className='list_buttonholder'>
                                            <button onClick={() => goForProjectDetails(item.primary_key, item.pro_name, item.pr_last_date)}>View</button>
                                            <button className='rightgap backtranparent'
                                                onClick={() => reactiveProject(item.primary_key)} title="Reactive"
                                            >
                                                <i className='ri-arrow-go-back-line'></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
